import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PaginationAndSorting')
export class PaginationAndSorting {
  @JsonProperty('pageNumber', Number, true) pageNumber = 0;
  @JsonProperty('pageSize', Number, true) pageSize = 10;
  @JsonProperty('sortBy', String, true) sortBy: string = undefined;
  @JsonProperty('sortDirection', String, true) sortDirection: string = undefined;
}
